import { StorageScope } from "../../../services/api/instances/storageApi/types/service_types";

export const getServiceObjectName = (service: StorageScope) => {
  return `services.create_${service}`;
};
